/* NSC : « Type de lettre » est obligatoire uniquement quand une lettre est saisie au centre du bouquet.
   Sans lettre, le choix est masqué et vidé (donc aucun supplément). */
(function () {
  function init(root) {
    var letterGroup = root.querySelector('[data-nsc-group][data-monogram="true"]');
    var typeGroup = Array.prototype.find.call(root.querySelectorAll('[data-nsc-group]'), function (g) {
      return g.dataset.label === 'Type de lettre';
    });
    if (!letterGroup || !typeGroup) return;
    var field = letterGroup.querySelector('input[type="text"], textarea');
    var select = typeGroup.querySelector('select');
    if (!field || !select) return;

    function sync(fire) {
      var hasLetter = field.value.trim().length > 0;
      typeGroup.style.display = hasLetter ? '' : 'none';
      if (hasLetter) {
        typeGroup.dataset.required = 'true';
        var first = select.querySelector('option[value=""]');
        if (first) first.textContent = 'Choisir un type de lettre';
      } else {
        delete typeGroup.dataset.required;
        typeGroup.classList.remove('is-invalid');
        var err = typeGroup.querySelector('.nso-group__error');
        if (err) err.hidden = true;
        if (select.value !== '') {
          select.value = '';
          if (fire) select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    field.addEventListener('input', function () { sync(true); });
    sync(false);
  }

  function start() {
    document.querySelectorAll('nsc-options').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();